module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', [_c('h2', [_c('span', {
    staticClass: "h2-inner"
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "firstInSection"
  }, [_vm._v("The dead girl drifted silently onward on the rippling surface of the swollen river, rolling from side to side as the current buffeted her. It snatched at her long hair and played with it, fanning it out across the surface and then tangling it up in a cat's cradle before unknotting it again on a whim. It had stopped raining and the moon slid out from behind the clouds to touch the body briefly with silver fingers. The river made a turn here and the current pulled her towards the bank where the water had burst through its former corset and inundated an area of bushes and trees. Twiggy hands caught at her clothing but the current did not want to be deprived of its plaything. It began to worry at the body, trying to pull it loose. The moon disappeared again and left them to dispute in darkness.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbe32110","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter3.vue
// module id = 72
// module chunks = 0